import { Route } from "react-router";
import React from "react";
import { ProtectedRoute } from "./components";
import {
  Notification,
  NotificationDetails,
  UserProfile,
  UserSettings,
} from "@/pages";
import { permissionsUsersReadonly, permissionsSettings } from "@/utils";

export const userRoutes = (_parentPath: string): React.ReactElement[] => [
  <Route
    key="profile"
    path="profile"
    element={
      <ProtectedRoute
        element={(<UserProfile />) as React.ReactElement<any>}
        codes={permissionsUsersReadonly}
      />
    }
  />,
  <Route
    key="settings"
    path="settings"
    element={
      <ProtectedRoute
        element={(<UserSettings />) as React.ReactElement<any>}
        codes={permissionsSettings}
        feature="common"
      />
    }
  />,
  <Route
    key="notifications"
    path="notifications"
    element={
      <ProtectedRoute
        element={(<Notification />) as React.ReactElement<any>}
        codes={permissionsUsersReadonly}
      />
    }
  />,
  <Route
    key="notification-details"
    path="notifications/:notificationId"
    element={
      <ProtectedRoute
        element={(<NotificationDetails />) as React.ReactElement<any>}
        codes={permissionsUsersReadonly}
      />
    }
  />,
];
